import { render } from "./ExamCardImage.vue?vue&type=template&id=e79d8b70&scoped=true"
import script from "./ExamCardImage.vue?vue&type=script&lang=js"
export * from "./ExamCardImage.vue?vue&type=script&lang=js"

import "./ExamCardImage.vue?vue&type=style&index=0&id=e79d8b70&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e79d8b70"]])

export default __exports__